import { Deserializable } from '../protocols/deserializable';
import { DateUtils } from '../../utils/date-utils';
import { Mentionable } from './mentionable';

export class BaseComment implements Deserializable {
  public id!: string;
  public authorId!: string;
  public comment!: string;
  public createdDate!: string;
  public readDate!: string | null;

  // Not from API
  public formattedDate!: string;
  public author!: Mentionable;
  public isVisibleExternally: boolean = false;

  onDeserialize(): void {
    if (!!this.createdDate) {
      this.formattedDate = DateUtils.formatISOStringToCurrentDateTimeWithoutTimeZone(this.createdDate);
    }
  }

  public getFormattedComment<T>(users: Mentionable[]): T {
    this.comment = this.comment.replace(/\n/g, '<br>');
    return {
      ...this,
      comment: this.comment.replace(/\{\{(\d+)\}\}/g, (_, id) => {
        const replacement = users.find(item => item.id === +id);
        return replacement ? `<span class="tagged-user">@${replacement.fullName}</span>` : '';
      })
    } as T;
  }
}
